/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Tax_InfoInputs */

const vi_shop_contact_tax_info = /** @type {(inputs: Shop_Contact_Tax_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MST / ĐKKD (trống = ẩn)`)
};

/**

* @param {Shop_Contact_Tax_InfoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_tax_info = /** @type {((inputs?: Shop_Contact_Tax_InfoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Tax_InfoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_tax_info(inputs)
});